import { styled, Typography, Chip, Autocomplete, Paper } from '@mui/material';

export const StyledPrescriptionSearchWrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
});

export const StyledPrescriptionSearch = styled(Autocomplete)({
  width: '100%',
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  '&.MuiAutocomplete-hasClearIcon .MuiOutlinedInput-root': {
    paddingRight: '9px !important',
  },
  '.MuiOutlinedInput-root': {
    paddingLeft: '0px',
  },
  '.MuiOutlinedInput-root .MuiAutocomplete-endAdornment': {
    top: '25%',
  },
});

export const StyledPrescriptionLabel = styled(Typography)({
  padding: '8px 12px',
  textTransform: 'uppercase',
  fontSize: '12px',
});

export const StyledPrescriptionChip = styled(Chip)({
  background: '#DEE7FF',
  borderRadius: '4px',
  height: 'auto',
});

export const StyledSearchRecommendations = styled(Paper)(({ theme }) => ({
  zIndex: 9999,
  marginTop: '-6px',
  width: '80%',
  left: '18%',
  position: 'inherit',
  [theme.breakpoints.down(992)]: {
    width: '100%',
    left: '0',
  },
  [theme.breakpoints.down(743)]: {
    left: '40px',
  },
}));
